import { useState, useEffect } from 'react'
import { Alert, CircularProgress, Container } from '@mui/material'
import { jwtDecode } from 'jwt-decode'
import { useNavigate } from 'react-router-dom'
import { useApiExam } from '../../api'
import Countdown from 'react-countdown'

export default function ExamResult() {
   const [loading, setLoading] = useState(true)
   const navigate = useNavigate()

   // Custom renderer supaya bisa kontrol saat selesai
   const renderer = ({ minutes, seconds, completed }) => {
      if (completed) {
         return <span>Mengalihkan ke halaman utama...</span>
      } else {
         return (
            <span>
               {minutes}:{seconds.toString().padStart(2, '0')}
            </span>
         )
      }
   }

   const { get_exam } = useApiExam()
   const [scoreData, setScoreData] = useState(null)

   const token = sessionStorage.getItem('exam_token')
   const decode = jwtDecode(token)
   useEffect(() => {
      get_exam(
         `/exam/result?exam_participant_id=${decode?.exam_participant_id}`
      )
         .then((res) => {
            if (res.error) {
               setScoreData({
                  score: 0,
               })
            }
            setScoreData(res)
            console.log(res, res.error)
            // sessionStorage.removeItem('exam_token')
         })
         .catch((err) => {
            console.error('Error fetching exam result:', err)
            setScoreData({
               score: 0,
            })
         })
         .finally(() => setLoading(false))
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return (
      <Container sx={{ mt: 5, textAlign: 'center' }}>
         {loading ? (
            <CircularProgress />
         ) : (
            scoreData && (
               <>
                  <Alert severity="info">Score Anda: {scoreData?.score}</Alert>
                  <Alert severity="warning">
                     Halaman ini hanya dimuat sekali, catat atau simpan skor
                     ujian anda
                  </Alert>

                  <Countdown
                     onComplete={() => navigate('/exam')}
                     date={Date.now() + 10 * 1000} // 1 menit
                     renderer={renderer}
                  />
               </>
            )
         )}
      </Container>
   )
}
